<template>
  <div class="order-info" v-if="orderInfo">
    <div>
      <span style="font-size: 16px; font-weight: bolder; line-height: 35px">
        {{ getChannelLabel() }}
      </span>
      <span
        class="order-status"
        :style="{
          backgroundColor: getStatusColor(),
          color: '#ffffff',
        }"
        v-if="showStatus && getStatusLabel()"
      >
        {{ getStatusLabel() }}
      </span>
      <span
        class="order-status"
        :style="{
          backgroundColor: getCancelColor(),
          color: '#ffffff',
        }"
        v-if="!showStatus && getCancelLabel()"
      >
        {{ getCancelLabel() }}
      </span>
      <span
        class="order-status"
        :style="{
          backgroundColor: getPaymentColor(),
          color: '#ffffff',
        }"
        v-if="getPaymentLabel()"
      >
        {{ getPaymentLabel() }}
      </span>
      <slot name="action" />
    </div>
    <div>
      <div>
        订单编号:
        <span>
          {{ orderInfo.guid }}
        </span>
      </div>
      <div v-if="orderInfo.unlockNumber">
        渠道单号:
        <span>
          {{ orderInfo.unlockNumber }}
        </span>
      </div>
      <div v-if="orderInfo.orderTime > 0">
        <span>
          下单时间:
          {{ new Date(orderInfo.orderTime).format("YYYY-MM-dd hh:mm:ss") }}
        </span>
      </div>
      <div v-if="orderInfo.createTime > 0">
        <span>
          创建时间:
          {{ new Date(orderInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
        </span>
      </div>
      <div v-if="orderInfo.storeInfo">门店名称: {{ orderInfo.storeInfo.name }}</div>
      <div v-if="orderInfo.handledBy">
        经手人员:
        <span>{{ orderInfo.handledBy }}</span>
      </div>
      <div v-if="orderInfo.memberInfo">
        客户账号:
        {{
          [orderInfo.memberInfo.nickname, orderInfo.memberInfo.phone]
            .filter((item) => !!item)
            .join("-")
        }}
      </div>
      <div v-if="orderInfo.consumeName">
        消费者姓名:
        {{ orderInfo.consumeName }}
      </div>
      <div v-if="orderInfo.consumePhone">
        消费者电话:
        {{ orderInfo.consumePhone }}
      </div>
      <div v-if="orderInfo.outboundGoodsCost > 0">
        出库商品成本:
        <span> {{ orderInfo.outboundGoodsCost || 0 }}元 </span>
      </div>
      <div v-if="orderInfo.returnGoodsCost > 0">
        退货商品成本:
        <span> {{ orderInfo.returnGoodsCost || 0 }}元 </span>
      </div>
      <div v-if="orderInfo.freightCost > 0">
        配送成本:
        <span> {{ orderInfo.freightCost || 0 }}元 </span>
      </div>
      <div v-if="orderInfo.freightAmount > 0">
        配送费用:
        <span> {{ orderInfo.freightAmount || 0 }}元 </span>
      </div>
      <div v-if="orderInfo.orderChannelCost > 0">
        渠道成本费:
        <span> {{ orderInfo.orderChannelCost || 0 }}元 </span>
      </div>
      <div v-if="orderInfo.optStatus == 4 && orderInfo.settlementAmount > 0">
        <div>
          预估毛利:
          <span> {{ getProfitAmount() }}元 </span>
        </div>
        <div>
          毛利润率:
          <span> {{ getProfitRate() }}% </span>
        </div>
      </div>
      <template v-if="orderInfo.orderType == 'channel'">
        <template>
          <div v-if="orderInfo.orderReceivedAmount > 0">
            订单收入:
            <span style="color: #f56c6c">
              {{ orderInfo.orderReceivedAmount || 0 }}元
            </span>
          </div>
        </template>
      </template>
      <template v-else>
        <div v-if="orderInfo.goodsAmount > 0">
          商品金额:
          <span> {{ orderInfo.goodsAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.serviceAmount > 0">
          服务费用:
          <span> {{ orderInfo.serviceAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.originalAmount > 0">
          订单原价:
          <span> {{ orderInfo.originalAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.discountAmount > 0">
          优惠金额:
          <span> {{ orderInfo.discountAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.totalAmount > 0">
          成交金额:
          <span> {{ orderInfo.totalAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.paymentAmount > 0">
          收款金额:
          <span> {{ orderInfo.paymentAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.refundedAmount > 0">
          退款金额:
          <span> {{ orderInfo.refundedAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.refundingAmount > 0">
          退款中金额:
          <span> {{ orderInfo.refundingAmount || 0 }}元 </span>
        </div>
        <div v-if="orderInfo.paymentChannelCost > 0">
          收款通道费:
          <span> {{ orderInfo.paymentChannelCost || 0 }}元 </span>
        </div>
        <template v-if="orderInfo.optCancel == 0 && orderInfo.optStatus == 1">
          <div
            v-if="orderInfo.totalAmount > 0"
            style="color: #333333; font-weight: bolder"
          >
            待收款金额:
            <span style="color: #f56c6c"> {{ orderInfo.totalAmount || 0 }}元 </span>
          </div>
          <div style="color: #333333">
            <span>请在</span>
            <span style="color: #f56c6c">
              {{ new Date(orderInfo.timeoutTime).format("YYYY-MM-dd hh:mm:ss") }}
            </span>
            <span>前完成收款</span>
          </div>
        </template>
        <template v-else-if="orderInfo.optStatus == 4">
          <div v-if="orderInfo.settlementAmount > 0">
            本单预计收入:
            <span style="color: #f56c6c"> {{ orderInfo.settlementAmount || 0 }}元 </span>
          </div>
        </template>
      </template>
    </div>
    <div label="备注信息" v-if="orderInfo.optRemark">
      <div class="wordwrap">
        备注信息: <span class="order-remark">{{ orderInfo.optRemark }}</span>
      </div>
    </div>
    <div label="错误提示" v-if="orderInfo.errorMessage">
      <div class="wordwrap">
        备注信息: <span class="order-error">{{ orderInfo.errorMessage }}</span>
      </div>
    </div>
    <div
      class="order-item-list"
      v-if="
        showCount &&
        (orderInfo.inventoryInfoCount > 0 ||
          orderInfo.paymentInfoCount > 0 ||
          orderInfo.paymentRefundCount > 0 ||
          orderInfo.vetPrescriptionCount > 0)
      "
    >
      <span
        @click="inventoryListClick"
        style="font-size: 14px; cursor: pointer; color: #909399; margin-right: 10px"
        v-if="orderInfo.inventoryInfoCount > 0"
      >
        共{{ orderInfo.inventoryInfoCount }}条库存记录
      </span>
      <span
        @click="paymentListClick"
        v-if="orderInfo.paymentInfoCount > 0"
        style="font-size: 14px; cursor: pointer; color: #3399ff; margin-right: 10px"
      >
        共{{ orderInfo.paymentInfoCount || 0 }}条支付记录
      </span>
      <span
        @click="refundListClick"
        v-if="orderInfo.paymentRefundCount > 0"
        style="font-size: 14px; cursor: pointer; color: #f56c6c; margin-right: 10px"
      >
        共{{ orderInfo.paymentRefundCount || 0 }}条退款记录
      </span>
      <span
        @click="prescriptionListClick"
        v-if="orderInfo.vetPrescriptionCount > 0 && orderInfo.optCancel == 0"
        style="font-size: 14px; cursor: pointer; color: #909399; margin-right: 10px"
      >
        共{{ orderInfo.vetPrescriptionCount || 0 }}条处方记录
      </span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.order-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.order-error {
  font-weight: bolder;
  line-height: 30px;
  color: #ff0000;
}

.order-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.order-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  color: #5c5c5c;
}
</style>

<script>
export default {
  props: {
    showCount: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
    orderInfo: {
      type: Object,
    },
  },
  methods: {
    inventoryListClick() {
      this.$emit("inventoryListClick", this.orderInfo);
    },
    paymentListClick() {
      this.$emit("paymentListClick", this.orderInfo);
    },
    refundListClick() {
      this.$emit("refundListClick", this.orderInfo);
    },
    prescriptionListClick() {
      this.$emit("prescriptionListClick", this.orderInfo);
    },
    getStatusColor() {
      if (this.orderInfo.optCancel == 1) {
        return "#809399";
      } else if (this.orderInfo.optCancel == 2) {
        return "#909399";
      } else if (this.orderInfo.optStatus == 0) {
        return "#5c5c5c";
      } else if (this.orderInfo.optStatus == 1) {
        return "#333333";
      } else if (this.orderInfo.optStatus == 2) {
        return "#6F88A1";
      } else if (this.orderInfo.optStatus == 3) {
        return "#409EFF";
      } else if (this.orderInfo.optStatus == 4) {
        return "#67C23A";
      }
      return "#919191";
    },
    getStatusLabel() {
      if (this.orderInfo.optCancel == 1) {
        return "取消中";
      } else if (this.orderInfo.optCancel == 2) {
        return "已取消";
      } else if (this.orderInfo.optStatus == 0) {
        return "处理中";
      } else if (this.orderInfo.optStatus == 1) {
        return "待收款";
      } else if (this.orderInfo.optStatus == 2) {
        return "待出库";
      } else if (this.orderInfo.optStatus == 3) {
        if (this.orderInfo.recipientType == 0) {
          return "自提-待取货";
        } else if (this.orderInfo.recipientType == 1) {
          return "待配送";
        }
        return "待发货";
      } else if (this.orderInfo.optStatus == 4) {
        return "已完成";
      }
      return "";
    },
    getCancelColor() {
      if (this.orderInfo.optCancel == 1) {
        return "#809399";
      } else if (this.orderInfo.optCancel == 2) {
        return "#909399";
      }
      return "#919191";
    },
    getCancelLabel() {
      if (this.orderInfo.optCancel == 1) {
        return "取消中";
      } else if (this.orderInfo.optCancel == 2) {
        return "已取消";
      }
      return "";
    },
    getPaymentColor() {
      if (!this.orderInfo) {
        return "#919191";
      }
      if (this.orderInfo.optPayment == 0) {
        return "#333333";
      } else if (this.orderInfo.optPayment == 1) {
        return "#333333";
      } else if (this.orderInfo.optPayment == 2) {
        return "#409EFF";
      } else if (this.orderInfo.optPayment == 3) {
        return "#67C23A";
      } else if (this.orderInfo.optPayment == 4) {
        return "#f56c6c";
      } else if (this.orderInfo.optPayment == 5) {
        return "#96B089";
      } else if (this.orderInfo.optPayment == 6) {
        return "#919191";
      }
      return "#919191";
    },
    getPaymentLabel() {
      if (!this.orderInfo) {
        return "";
      }
      if (this.orderInfo.orderType == "offline") {
        if (this.orderInfo.optPayment == 1) {
          return "支付失败";
        } else if (this.orderInfo.optPayment == 2) {
          return "支付中";
        } else if (this.orderInfo.optPayment == 4) {
          return "退款处理中";
        } else if (this.orderInfo.optPayment == 5) {
          return "已退款" + this.orderInfo.refundedAmount + "元";
        } else if (this.orderInfo.optPayment == 6) {
          return "已全额退款";
        }
      }
      return "";
    },
    getChannelLabel() {
      if (this.orderInfo.orderType === "channel") {
        return this.orderInfo.orderSerial;
      } else if (
        this.orderInfo.orderType === "other" &&
        this.orderInfo.orderChannelInfo
      ) {
        return `${this.orderInfo.orderChannelInfo.name}${this.orderInfo.orderSerial}`;
      } else {
        return `线下订单${this.orderInfo.orderSerial}`;
      }
    },
    getProfitAmount() {
      if (this.orderInfo && this.orderInfo.settlementAmount > 0) {
        return Number(
          this.orderInfo.settlementAmount +
            this.orderInfo.returnGoodsCost -
            this.orderInfo.outboundGoodsCost -
            this.orderInfo.freightCost
        ).toFixed(2);
      }
      return 0;
    },
    getProfitRate() {
      if (this.orderInfo && this.orderInfo.settlementAmount > 0) {
        return Number(
          (100 *
            (this.orderInfo.settlementAmount +
              this.orderInfo.returnGoodsCost -
              this.orderInfo.outboundGoodsCost -
              this.orderInfo.freightCost)) /
            this.orderInfo.settlementAmount
        ).toFixed(2);
      }
      return 0;
    },
  },
};
</script>
